export class DeviceTypes {
    public static readonly LINK = 'link';
    public static readonly BUTTON = 'button';
    public static readonly ETHERNET_IO = '101';
}
